module.exports = __webpack_public_path__ + "img/CW_Robert_Ellis+St_Vincent-4255.2bf31c5a.jpg";